'use client'

import { useTranslation } from 'react-i18next'
import { AuthMethodSelector } from '@/features/auth/ui/AuthMethodSelector'
import { AuthLayout } from './AuthLayout'

export function AuthEntryPage() {
  const { t } = useTranslation()
  return (
    <AuthLayout
      title={t('auth.login.title')}
      description={t('auth.login.description')}
    >
      <AuthMethodSelector />
    </AuthLayout>
  )
}
